export default __webpack_public_path__ + "static/media/bannerHTP.ca896cdc.png";